export default __webpack_public_path__ + "static/media/chevron_left_color.a97b932d.svg";